import axios from '@/config/axios'


const baseUrl = '/v1/api/mg/maAccount'


export const listAccounts =(query) => axios.get(`${baseUrl}`,{params: query})


export const createNewAccountInfo = (account) => axios.post(`${baseUrl}`, account)

export const updateAccount = (account) => axios.put(`${baseUrl}/${account.uid}`, account)

export const changeStatus = (uid) => axios.patch(`${baseUrl}/${uid}/status`)
